<template>
  <div class="base-info">
    <formTemplate :title="'销售信息'" :rules="rules" :formData="sale_info">
      <template v-slot:body>
        <el-form-item label="是否是多规格" prop="has_spec">
          <el-switch v-model="sale_info.has_spec" active-text="启用多规格" inactive-text="单规格" style="margin-left:20px" />
          <span class="primary-label">可自定义规格</span>
        </el-form-item>
        <el-form-item label="实际售价" prop="sale_price">
          <el-input v-model="sale_info.sale_price" style="width: 30%;" placeholder="实际售价" /><span
            class="margin-left-sm">元</span>
        </el-form-item>
        <el-form-item label="市场价" prop="market_price">
          <el-input v-model="sale_info.market_price" style="width: 30%;" placeholder="市场价" /><span
            class="margin-left-sm">元</span>
        </el-form-item>
        <el-form-item label="成本价" prop="cost_price">
          <el-input v-model="sale_info.cost_price" style="width: 30%;" placeholder="成本价" /><span
            class="margin-left-sm">元</span>
        </el-form-item>
        <el-form-item label="库存数量" prop="stock">
          <el-input v-model="sale_info.stock" style="width: 30%;" placeholder="库存数量" /><span
            class="margin-left-sm">件</span>
        </el-form-item>
        <el-form-item label="库存预警数量" prop="stock_warning">
          <el-input v-model="sale_info.stock_warning" style="width: 30%;" placeholder="库存预警数量" /><span
            class="margin-left-sm">件</span><span class="primary-label reda-text">库存低于这个值时报警</span>
        </el-form-item>
        <el-form-item label="重量" prop="weight">
          <el-input v-model="sale_info.weight" style="width: 30%;" placeholder="重量" /><span
            class="margin-left-sm">kg</span><span class="primary-label">例：0.45</span>
        </el-form-item>
        <el-form-item label="体积" prop="volume">
          <el-input v-model="sale_info.volume" style="width: 30%;" placeholder="体积" /><span
            class="margin-left-sm">m³</span><span class="primary-label">例：0.03</span>
        </el-form-item>
        <!-- SKU 编号输入框 -->
        <!-- <el-form-item label="SKU 编号" prop="sku_no">
          <el-input v-model="sale_info.sku_no" style="width: 30%;" placeholder="请输入SKU编号" clearable>
          </el-input>
          <div class="form-tip" v-if="!sale_info.sku_no">
            请输入唯一的SKU编号
          </div>
        </el-form-item> -->

        <!-- 是否默认选项（开关和单选框两种风格供选择） -->

        <!-- 风格1: 使用开关 Switch -->
        <!-- <el-form-item label="是否默认" prop="is_default">
          <el-switch v-model="sale_info.is_default" :active-value="true" :inactive-value="false" active-text="是"
            inactive-text="否">
          </el-switch>
        </el-form-item> -->
        <el-form-item label="新建规格" v-if="sale_info.has_spec">
          <el-input v-model="spec_value" style="width: 30%;" placeholder="输入规格类型名称" />
          <el-button type="primary" style="margin-left: 20px;" size="medium" plain @click="addSpec(spec_value)">
            新建规格
          </el-button>
        </el-form-item>
        <!-- 每个规格的详细内容 -->
        <div v-if="sale_info.has_spec && Object.keys(sale_info.spec_json).length > 0">
          <el-form-item :label="key" v-for="(item, key) in sale_info.spec_json" :key="key">
            <el-select v-model="sale_info.spec_json[key]" style="width: 60%;" multiple filterable allow-create
              default-first-option :placeholder="'添加' + key + '规格'">
            </el-select>
            <el-button type="danger" style="margin-left: 20px;" size="medium" plain @click="deleteSpec(key)">
              删除规格
            </el-button>
            <span class="primary-label">输入自定义规格，回车创建</span>
          </el-form-item>
        </div>
        <!-- 不通规格的组合价格 -->
        <div v-if="sale_info.has_spec && Object.keys(sale_info.spec_json).length > 0">
          <el-form-item label="规则组合明细">
            <el-table :data="group_list" size="small" border stripe style="width:100%">
              <el-table-column key="status" prop="status" label="sku状态" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.status" :true-label="1" :false-label="0">启用</el-checkbox>
                </template>
              </el-table-column>
              <el-table-column key="sku_no" prop="sku_no" label="sku编号" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sku_no" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column>
              <el-table-column key="barcode" prop="barcode" label="商品条码" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.barcode" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column>
              <el-table-column key="is_default" prop="is_default" label="默认sku" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="have_default === true && (scope.row.is_default === false || scope.row.is_default === 'false')"
                    v-model="scope.row.is_default" true-label="true" false-label="false">默认</el-checkbox>
                </template>
              </el-table-column>
              <!-- 循环自定义规格 -->
              <el-table-column v-for="col in specDataColumns" :key="col" :prop="col" :label="col" min-width="100"
                width="150">
                <template slot-scope="scope">
                  <el-select size="mini" v-model="scope.row.spec_json[col]" style="width: 100%;" placeholder="选择规格值">
                    <el-option v-for="item in sale_info.spec_json[col]" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column key="price" prop="price" label="价格" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column>
              <el-table-column key="stock" prop="stock" label="库存" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.stock" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column>
              <el-table-column key="stock_warning" prop="stock_warning" label="库存预警" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.stock_warning" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column><el-table-column key="weight" prop="weight" label="重量" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.weight" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column><el-table-column key="volume" prop="volume" label="体积" min-width="100" width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.volume" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column>
              <!-- <el-table-column key="price" prop="price" label="价格" min-width="100">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column>

              <el-table-column key="price" prop="price" label="价格" min-width="100">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" :min="0" size="mini" style="width:100%" />
                </template>
              </el-table-column> -->

              <el-table-column label="操作" width="60" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="removeSpecRow(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" size="small" plain @click="addSpecRow" style="margin-top:10px">
              <i class="el-icon-plus"></i> 新增规格组合
            </el-button>
            <!-- <el-button type="primary" size="small" plain @click="ConsoleLog" style="margin-top:10px">
              <i class="el-icon-plus"></i> 输出组合
            </el-button>
             --><el-button type="primary" size="small" plain @click="getValue" style="margin-top:10px">
              <i class="el-icon-plus"></i> 销售信息
            </el-button>
          </el-form-item>

        </div>

      </template>
    </formTemplate>
  </div>

</template>
<script>

//eslint-disable-next-line
import { onlinesSkuCreate, onlineSkuQuery, onlinesSkuUpdate } from "@/api/onlines/goods.js";
import { showDialog, myFixed } from "@/js/public.js";
import formTemplate from './formTemplate.vue';
export default {
  name: 'saleInfo',
  components: {
    formTemplate
  },
  data() {
    return {
      spec_value: "", //规格
      group_list: [], //skulist
      //spec_json: {},
      sale_info: {
        guid: "",
        sku_no: "",
        barcode: "",
        is_default: false,
        has_spec: false, //是否有规格
        sale_price: 0, //实际售价
        market_price: 0, //市场价
        cost_price: 0, //成本价
        stock: 0, //库存数量
        stock_warning: 0, //库存数量预警
        weight: 0, //重量
        volume: 0, //体积
        spec_json: {}
      },
      rules: {
        sale_price: [
          { required: true, min: 0.01, message: '实际售价应大于0.01', trigger: 'blur' }
        ],
        market_price: [
          { required: false, min: 0.01, message: '市场价', trigger: 'blur' }
        ],
        cost_price: [
          { required: false, min: 0.01, message: '请输入成本价', trigger: 'blur' }
        ],
        stock: [
          { required: true, min: 1, message: '库存数量应该大于1', trigger: 'blur' }
        ],
        stock_warning: [
          { required: false, message: '请输入库存预警数量', trigger: 'blur' }
        ],
        weight: [
          { required: true, min: 0.01, message: '重量应大于0.01', trigger: 'blur' }
        ],
        volume: [
          { required: false, message: '请输入体积', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    // 动态获取spec_data的所有键作为表格列
    specDataColumns() {
      if (this.sale_info.spec_json && Object.keys(this.sale_info.spec_json).length > 0) {
        return Object.keys(this.sale_info.spec_json);
      }
      return [];
    },
    have_default() {
      for (let i = 0; i < this.group_list.length; i++) {
        console.log("this.group_list[i]", this.group_list[i].is_default);
        //eslint-disable-next-line
        if (this.group_list[i].is_default == true || this.group_list[i].is_default == 'true') {
          return true;
        }
      }
      return false
    }
  },
  methods: {
    getValue() {
      return {
        ...this.sale_info,
        cost_price: Number(this.sale_info.cost_price) * 100,
        market_price: Number(this.sale_info.market_price) * 100,
        sale_price: Number(this.sale_info.sale_price) * 100
      }
    },
    setValue(d) {
      this.sale_info = d;
      //this.sale_info.is_default = this.sale_info.is_default ? this.sale_info.is_default : true;
      //eslint-disable-next-line
      this.sale_info.has_spec = this.sale_info.has_spec === "False" ? false : true;
      this.sale_info.price = Number(this.sale_info.price);
      this.sale_info.cost_price = Number(this.sale_info.cost_price);
      this.sale_info.market_price = Number(this.sale_info.market_price);
      this.sale_info.sale_price = Number(this.sale_info.sale_price);

      console.log("saleInfo组件修改后的值", this.sale_info);

      this.getSkuList();
      //TODO: 获取sku
      //this.group_list = this.sale_info.spec_json.group_list;
    },
    /**
     * 获取商品sku
     */
    async getSkuList() {
      const res = await onlineSkuQuery(this.sale_info.guid);
      if (res.length) {
        res.forEach((item, index) => {
          this.group_list.push({
            sku_no: item.sku_no,
            barcode: item.barcode,
            stock: item.stock,
            price: myFixed(item.price * 0.01, 2),
            weight: item.weight,
            volume: item.volume,
            is_default: item.is_default === "True" ?? false,
            sort_order: item.sort_order,
            status: Number(item.status),
            stock_warning: item.stock_warning,
            spec_json: item.spec_json ? JSON.parse(item.spec_json) : {}
          });
        })
      }
      console.log("res----------------------SKU", res);
    },
    /**
     * 创建商品sku
     * @param {string} guid 商品guid
     */
    async generateSku(guid) {
      console.log("guid-----------------", guid);
      console.log("guid-----------------", guid.length > 0);

      console.log("guid-----------------", guid && guid.length > 0);

      console.log("guid-----------------", this.sale_info.guid);
      /* eslint-disable */
      let list = [];
      for (let i = 0; i < this.group_list.length; i++) {
        let data = {
          ...this.group_list[i],
          goods_guid: guid && guid.length > 0 ? guid : this.sale_info.guid
        }
        console.log(data);
        list.push(onlinesSkuCreate(data));
        console.log("data------------------", data);
      }
      const res = await Promise.all(list);
      console.log("创建sku", res);
      if (res[0].state === true) {
        this.successMessage(res[0].message);
      }
      /* const data = {
        goods_guid,
        ...this.sale_info,
        spec_json: {
          spec_json: this.sale_info.spec_json,
          group_list: this.group_list
        }
      }
      console.log("data----------", data);

      const res = await onlinesSkuCreate(data);
      console.log("创建商品sku", res); */
    },
    async updateSku() {
      /*  console.log("guid-----------------", guid);
       console.log("guid-----------------", guid.length > 0);
       console.log("guid-----------------", guid && guid.length > 0);
       console.log("guid-----------------", this.sale_info.guid); */
      /* eslint-disable */
      let list = [];
      for (let i = 0; i < this.group_list.length; i++) {
        let data = {
          ...this.group_list[i],
          price: this.group_list[i].price * 100,
          goods_guid: guid && guid.length > 0 ? guid : this.sale_info.guid
        }
        console.log(data);
        list.push(onlinesSkuCreate(data));
        console.log("data------------------", data);
      }
      const res = await Promise.all(list);
      console.log("修改sku", res);
      if (res[0].state === true) {
        this.successMessage(res[0].message);
      }
    },
    ConsoleLog() {
      console.log("输出规格", this.sale_info.spec_json);

      console.log("规则组合", this.group_list);
      this.generateSku();
    },
    //添加组合
    addSpecRow() {
      /* eslint-disable */
      this.group_list.push({
        barcode: "",
        stock: 0,
        price: 0,
        weight: 0,
        volume: 0,
        is_default: this.group_list.length === 0 ? true : false,
        sort_order: 1,
        status: 1,
        stock_warning: 0,
        spec_json: {}
      });
      /* eslint-enable */
    },
    /**
     * 添加规格
     */
    addSpec() {
      if (this.spec_value.trim() === "") {
        this.$message.warning("规格名称不能为空");
        return;
      }
      if (this.sale_info.spec_json[this.spec_value]) {
        this.$message.warning("规格名称已经存在");
        return;
      }
      this.$nextTick(() => {
        this.$set(this.sale_info.spec_json, this.spec_value, []);
        this.spec_value = "";
      })
    },
    /**
     * 删除规格
     * @param key
     */
    async deleteSpec(key) {
      if (await showDialog("删除规格", "确定删除规格吗？删除后相关的规格数据也会被删除")) {
        this.sale_info.spec_json = Object.keys(this.sale_info.spec_json).reduce((result, currentKey) => {
          if (currentKey !== key) {
            result[currentKey] = this.sale_info.spec_json[currentKey];
          }
          return result;
        }, {});
      }
    },
    /**
     * 删除组合明细
     * @param {number} index - 要删除的组合索引
     */
    async removeSpecRow(index) {
      if (await showDialog("删除组合", "确定删除组合吗？")) {
        this.group_list = this.group_list.filter((item, i) => i !== index);
      }
    }
  }
};
</script>
<style lang="less" scoped></style>